import { FC } from 'react';
import styles from './SkeletonLoader.module.scss';

const SkeletonLoader: FC<{ isLoading: boolean }> = ({ isLoading, children }) => {
  if (!isLoading) return <>{children}</>;
  return (
    <div className={styles['skeleton-loader']}>
      <div className={styles['skeleton-main-body']}></div>
    </div>
  );
};
export default SkeletonLoader;
